import { BlogPostListItem } from './types'

export const getSectionNames = (item: BlogPostListItem) => item.section.map(({ title }) => title)

export const isLinkedItem = (item: BlogPostListItem) => item.isUsedInSection || !!item.section.length

export const getDeleteDisabledReason = (item: BlogPostListItem, entityName: string) => {
  const sectionNames = getSectionNames(item)
  const activeSectionText = sectionNames.length ? sectionNames.join(', ') : 'a section'

  return `Cannot delete: This ${entityName} is currently active in ${activeSectionText}. Remove it from the section first.`
}

export const getWithSectionFilter = (statusId: string) => {
  if (statusId === 'linked') {
    return true
  }

  if (statusId === 'orphaned') {
    return false
  }

  return undefined
}

export const getNumberParam = (
  value: string | null,
  defaultValue: number,
  min: number,
  max = Number.MAX_SAFE_INTEGER
) => {
  const numberValue = Number(value)

  if (!Number.isInteger(numberValue) || numberValue < min || numberValue > max) {
    return defaultValue
  }

  return numberValue
}
